export const TRACK_CLASSNAME = "sequence-track";
export const CLIP_CLASSNAME = "sequence-clip";
export const TIMELINE_TRACKS_CONTAINER_ID = "sequence-timeline-tracks-container";
export const TIMELINE_CONTROLS_ELEMENT_ID = "sequence-timeline-controls";
export const TIMELINE_ELEMENT_ID = "sequence-timeline";